<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h"><span><i>Cast of Characters</i></span></p>
<p class="section-1">INSPECTOR QUEEN</p>
<p class="normal2">Old war horse of Centre Street. Only orders from Washington could have persuaded him to leave New York</p>
<p class="section-1">ELLERY QUEEN</p>
<p class="normal2">He was badly miscast as fall guy for a murderer</p>
<p class="section-1">ABEL BENDIGO</p>
<p class="normal2">The King’s ‘prime minister’. Deceptively undistinguished and blandly uncooperative</p>
<p class="section-1">COLONEL SPRING</p>
<p class="normal2">The gold-braided head of the King’s private Gestapo</p>
<p class="section-1">KING KANE BENDIGO</p>
<p class="normal2">Munitions tycoon and monarch of Bendigo Island. Handsome, ruthless — but not invulnerable</p>
<p class="section-1">JUDAH BENDIGO</p>
<p class="normal2">The third brother. An ingenuous lush who specialized in Segonzac V.S.O.P.</p>
<p class="section-1">KARLA BENDIGO</p>
<p class="normal2">A Technicolor beauty who could have posed for Titian. Altogether, a fitting queen for the King</p>
<p class="section-1">MAX</p>
<p class="normal2">The King’s ‘court jester’. A troglodyte with only one loyalty</p>
<p class="section-1">Dr. STORM</p>
<p class="normal2">Surgeon-General of Bendigo Island, whose conversation ran to the anatomically bawdy</p>
<p class="section-1">IMMANUEL PEABODY</p>
<p class="normal2">Chief legal adviser to the King. Lean and swarthy, with a catty smile</p>
<p class="section-1">Dr. AKST</p>
<p class="normal2">A tired young man who, according to Karla, spent his time fiddling with atoms</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?73ae6b8a